import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
export var ITEMS_PROP_TYPE = PropTypes.arrayOf(PropTypes.shape({
  content: EBPropTypes.translation.isRequired,
  subcontent: PropTypes.node,
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  quantity: PropTypes.string,
  color: PropTypes.string
}));
export var BREAKDOWN_ITEMS_PROP_TYPE = PropTypes.arrayOf(PropTypes.shape({
  content: EBPropTypes.translation.isRequired,
  subcontent: EBPropTypes.string,
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  color: PropTypes.string,
  expansionContent: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  })),
  infoTooltipContent: EBPropTypes.string
}));